<template>
  <div class="leftres">
    <div>
      <!-- v-show="showorhide" -->
      <div :class=" showorhide ? 'inputtop' : 'inputtops' ">
        <div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
          <Commondropdownlist ref="prselect" :key="index" :options="item.options" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
        </div>
        <div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
          <CommonBtngroup ref="btngroup" :show="showorhide" @showclick="showclick" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
        </div>
        <div style="height:10px;">
        </div>
      </div>
      <div class="TableBox" style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
        <Primarydealerfilestable :tableData="tableDatas" :total="totals" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></Primarydealerfilestable>
      </div>
      <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK" :src="'../assets/icon/icon-errors.png'">
        <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
      </Dialog>
    </div>
  </div>
</template>

<script>
import Commondropdownlist from '../../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../../components/commongroup.vue'
import Dialog from '../../../components/dialog.vue'
import Primarydealerfilestable from './components/primarydealerfilestable.vue'
import { BaOrganizationList } from '@/api/home'
export default {
  components: {
    Commondropdownlist,
    CommonBtngroup,
    Primarydealerfilestable,
    Dialog
  },
  props: {
    tableData: {
      type: Array,
      default: Array
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showorhide: true,
      state: 1,
      topboo: false,
      dialogVisibles: false,
      pageindex: 1,
      pageSize: 20,
      tableDatas: this.tableData,
      totals: this.total,
      companyID: '',
      companyName: '',
      parentId: '',
      actived: '',
      formdatas: [
        {
          inputdata: '',
          title: '公司编号',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '210px'
        },
        {
          inputdata: '',
          title: '公司名称',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '210px'
        },
      ],
      formdata: [
        {
          inputdata: '',
          title: '公司编号',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '230px'
        },
        {
          inputdata: '',
          title: '公司名称',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '230px'
        },
        {
          inputdata: '',
          title: '父级编码',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '230px'
        },
        {
          inputdata: '',
          title: '是否启用',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请选择',
          types: '',
          inputtype: 'select',
          width: '230px',
          options: [
            {
              value: '全部',
              key: ''
            },
            {
              value: '停用',
              key: '0'
            }, {
              value: '启用',
              key: '1'
            }
          ],

        },
      ]
    }
  },
  computed: {

  },
  mounted() {
    this.baOrganizationList()
  },
  methods: {
    async baOrganizationList() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        data,
        code
      } = await BaOrganizationList({
        companyID: this.companyID,
        companyName: this.companyName,
        parentId: this.parentId,
        actived: this.actived,
        pageSize: this.pageSize,
        pageIndex: this.pageindex
      })
      //console.log(code, data)
      if (code == 0) {
        this.totals = data.Count
        if (data.data) {
          this.tableDatas = data.data

        }
      }
      loading.close();
    },
    reset() {
      this.$refs.prselect.map((item, index) => {
        item.modelvalue = ''
      })
    },
    cancel() {
      this.dialogVisibles = false
    },
    dialogOK() {
      this.dialogVisibles = false
    },
    hide() {
      this.showorhide = false

    },
    hides() {
      // this.topboo = true
      this.showorhide = false
    },
    showclick() {
      // this.topboo = false
      this.showorhide = true
      console.log(this.formdatas, this.formdata, 'formdatas');
    },
    select() {
        this.pageindex = 1
      try {
        this.companyID = this.$refs.prselect[0].modelvalue
        this.companyName = this.$refs.prselect[1].modelvalue
        this.parentId = this.$refs.prselect[2].modelvalue
        this.actived = this.$refs.prselect[3].modelvalue == "全部" ? "" : this.$refs.prselect[3].modelvalue
        this.baOrganizationList()
      } catch (error) {
        this.baOrganizationList()
      }
    },
    handleCurrentChange(pageindex) {
      this.pageindex = pageindex
      this.baOrganizationList()
    },
    handleSizeChange(paegSzie) {
      this.pageSize = paegSzie
      this.baOrganizationList()
    },
  },
  watch: {
    tableData(newVal) {
      this.tableDatas = newVal
    },
    total(newVal) {
      this.totals = newVal
    },
    showorhide: {
      handler(newVal, oldVal) {
        console.log(this.formdata);
        console.log(newVal, oldVal);
      },
      deep: true
    }
  }

}
</script>

<style lang="less" scoped>
.inputtop {
  width: 980px;
  height: 50px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 70px;
  // animation: shows 0.05s ease-in;
  overflow: hidden;
  position: relative;
  transition: all .3s;
}
.inputtops {
  width: 980px;
  height: 0px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 9px;
  padding-bottom: 64px;
  overflow: hidden;
  position: relative;
  transition: all .3s;
  // animation: hides 0.3s linear forwards;
}

.Btngroup {
  display: inline-block;
  float: right;
  margin-right: 30px;
  width: 342px;
  height: 50px;
  background-color: #ffffff;
  position: relative;
  bottom: 45px;
}
.Btngroups {
  display: inline-block;
  float: right;
  margin-top: 5px;
  margin-right: 30px;
}
</style>